import React from 'react';
// logic
// components
import CarrierUserForm from './components/carrierUsers/carrierUserForm';
import carrierUseFormSchema from './components/carrierUsers/carrierUseFormSchema';
import carrierUserFormDefaultValues from './components/carrierUsers/carrierUserFormDefaultValues';
import ToolbarWithNoPortal from 'modules/carriersv2/toolbarWithNoPortal';
import PageContent from 'modules/emergencies/components/ui/page/pageContent';
import styled from 'styled-components';
import NewCarrierUserPageToolbar from './newCarrierUserPageToolbar';
import createCarrierUser from './api/createCarrierUser';
import { useHistory } from 'react-router-dom';
import { mutate } from 'swr';

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const useNewCarriersUsersPage = () => {
  const history = useHistory();
  const onSubmit = async ({ carrierUserDto }) => {
    await createCarrierUser({ carrierUserDto });
    mutate((key) => {
      return typeof key === 'string' && key.startsWith('carrierUser-');
    });
    history.push(`/carrier/${carrierUserDto.carrier_id}/edit`);
  };
  const onCancel = () => {};
  const validationSchema = carrierUseFormSchema;
  const initialValues = { ...carrierUserFormDefaultValues };
  const isReadOnly = false;
  const isEdit = false;
  return {
    onSubmit,
    onCancel,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
  };
};

const NewCarrierUserPage = ({ carrierId }) => {
  const { onSubmit, onCancel, validationSchema, initialValues, isReadOnly, isEdit } =
    useNewCarriersUsersPage();

  const carrierUserFormData = {
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    onSubmit,
    onCancel,
    carrierId,
  };

  return (
    <>
      <Layout>
        <ToolbarWithNoPortal>
          <NewCarrierUserPageToolbar carrierId={carrierId} />
        </ToolbarWithNoPortal>
        <PageContent>
          <CarrierUserForm carrierUserFormData={carrierUserFormData} />
        </PageContent>
      </Layout>
    </>
  );
};

export default NewCarrierUserPage;
